<h1 class="h3 mb-2 text-gray-800">Pacientes</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Lista de Pacientes</h6>
    </div>
    <div class="card-body">
        <div *ngIf="casos.length==0">
            Necesita insertar un caso
        </div>
        <div *ngIf="casos.length > 0" class="table-responsive">
            <table [dtOptions]="dtOptions" datatable class="row-border hover">
                <thead>
                    <tr>
                        <th>N&ordm;</th>
                        <th>Paciente</th>
                        <th>CI</th>
                        <th>Género</th>
                        <th>Fecha Nacimiento</th>
                        <th>Fecha de ingreso</th>
                        <th>Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let caso of casos; let i = index;">
                        <td>{{casos.length-i}}</td>
                        <td>{{caso.paciente}}</td>
                        <td>{{caso.paciente}}</td>
                        <td>{{getGenero(caso.genero)}}</td>
                        <td>{{caso.fechaNacimiento}}</td>
                        <td>{{getFechaCreacion(caso.created_at)}}</td>
                        <td>
                            <div>{{getEstado(caso)}}</div>
                            <ng-container
                                *ngIf="caso.status == estadosCaso.CASO_RECHAZADO_ENVIE_INFO || caso.status == estadosCaso.PAGO_INICIAL_ERRONEO|| caso.status == estadosCaso.PAGO_TRATAMIENTO_ERRONEO || caso.status == estadosCaso.CASO_ENTREGADO_RECHAZADO">
                                <div><b>Motivo:</b> {{caso.motivo_rechazo}}</div>
                            </ng-container>
                            <ng-container *ngIf="caso.status == estadosCaso.PAGO_TRATAMIENTO_COMPROBADO">
                                <div><b>Dirección entrega:</b> {{caso.direccion_entrega}}</div>
                                <div *ngIf="caso.latitudEntrega"><a [href]="getGoogleMapsLink(caso)" target="_blank">Ver
                                        ubicación</a></div>
                            </ng-container>
                        </td>
                        <td><a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-primary">Ver paciente</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>